import React from "react";
import * as d3 from "d3";
import styles from "./TimelineText.module.css";

const parse_time = d3.timeParse("%m/%d/%Y");

const TimelineText = ({ data }) => {
  const homicides = d3.sum(data, (d) => d[1]);
  const highest_val = d3.max(data, (d) => d[1]);
  const highest_homicide = data.filter((d) => d[1] === highest_val);

  let timeline_text;

  // ${highest_homicide.map(
  //   (d, i) => {
  //     return i === highest_homicide.length - 1
  //       ? "and " + d3.timeFormat("%B %e")(parse_time(d[0]))
  //       : d3.timeFormat("%B %e")(parse_time(d[0])) + " ";
  //   }
  // )}
  if (highest_homicide.length > 1) {
    if (highest_homicide.length === 2) {
      timeline_text = `The deadliest days have been ${d3.timeFormat("%B %e")(
        parse_time(highest_homicide[0][0])
      )} and ${d3.timeFormat("%B %e")(
        parse_time(highest_homicide[1][0])
      )} with ${highest_val} homicides each.
`;
    } else {
      timeline_text = `
          The deadliest days in 2021 were
          ${highest_homicide.map((d, i) => {
            return i === highest_homicide.length - 1
              ? "and " + d3.timeFormat("%B %e")(parse_time(d[0]))
              : d3.timeFormat("%B %e")(parse_time(d[0])) + ", ";
          })}
          with ${highest_val} homicides each.
        `;
    }
  } else {
    timeline_text = `
        The deadliest day in 2021 was{" "}
        ${d3.timeFormat("%B %e")(parse_time(highest_homicide[0]))} with
        ${highest_val} homicides.
      `;
  }

  return (
    <div className={styles.TimelineText}>
      <p>
        There have been {homicides} homicides so far in 2021. {timeline_text}
      </p>
    </div>
  );
};

export default TimelineText;
